module.exports = __webpack_public_path__ + "img/home-logo.0d645034.png";